/**
 * Résolveur de statut de présence centralisé.
 * Utilisé par la grille (equipe/list.tsx), le dashboard (dashboard.tsx)
 * et la vue annuelle.
 *
 * @param schedule        La ligne TechnicianSchedule de la semaine, ou null/undefined
 *                        si aucune ligne n'existe pour ce collaborateur cette semaine.
 * @param dayKey          Clé de la colonne jour, ex. "mondayStatus", "tuesdayStatus", …
 * @param alternanceStatut Statut d'alternance pour ce (technicien, date) issu de
 *                        alternance_jours, ou undefined si aucun.
 * @returns               La valeur de statut (string).
 *
 * Hiérarchie de résolution :
 *   1. Saisie manuelle planificateur (schedule[dayKey] non-null/non-vide)
 *   2. Calendrier d'alternance (alternanceStatut fourni en argument)
 *   3. Défaut : "bureau"
 */
export function resolveDayStatus(
  schedule: Record<string, any> | null | undefined,
  dayKey: string,
  alternanceStatut?: string | null
): string {
  // 1. Saisie manuelle du planificateur — priorité absolue
  if (schedule && schedule[dayKey] != null && schedule[dayKey] !== "") {
    return schedule[dayKey] as string;
  }
  // 2. Calendrier d'alternance
  if (alternanceStatut) {
    return alternanceStatut;
  }
  // 3. Défaut
  return "bureau";
}

/** Clés de colonnes par index de jour (lundi=0 … vendredi=4). */
export const DAY_STATUS_KEYS = [
  "mondayStatus",
  "tuesdayStatus",
  "wednesdayStatus",
  "thursdayStatus",
  "fridayStatus",
] as const;
